import {createContext, useContext} from 'react';
import {ICustomerResponse, ICustomerUpdateRequest} from 'types';

export interface ICustomerContext {
  customer: ICustomerResponse;
  isLoadingUpdate: boolean;
  isLoadingGetting: boolean;
  isLoadingUpdateSuccess: boolean;
  updateCustomerData: (data: ICustomerUpdateRequest, showToast: boolean) => void;
  refetchCustomer: () => void;
}

export const CustomerContext = createContext<ICustomerContext>({
  customer: {} as ICustomerResponse,
  isLoadingUpdate: false,
  isLoadingGetting: false,
  isLoadingUpdateSuccess: false,
  updateCustomerData: () => {},
  refetchCustomer: () => {},
});

export const useCustomerContext = () => {
  const context = useContext(CustomerContext);

  if (!context) {
    throw new Error('useCustomerContext must be used inside a `CustomerProvider`');
  }

  return context;
};
